export default __webpack_public_path__ + "static/media/Vote.2b5deef6.svg";